import { render } from "./agent.vue?vue&type=template&id=88468b00"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"

import "./agent.vue?vue&type=style&index=0&id=88468b00&lang=scss"

import exportComponent from "D:\\wwwroot\\yunchi\\yc-vue-source\\yunman\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__